import { AutocompleteListItem } from "models/propTypes/listPropTypes";
import { useInvoiceService } from "serviceHooks";

function useArticleSearch() {
  const invoiceService = useInvoiceService();
  const onArticleSearch = async (searchText: string) => {
    return searchText
      ? invoiceService.searchArticles(searchText).then((res) => {
          const options: AutocompleteListItem[] = res.map((item) => ({
            id: item.id,
            value: item.name ?? "",
            data: item,
          }));

          return options;
        })
      : [];
  };

  return onArticleSearch;
}

export default useArticleSearch;
